import React, { createContext } from 'react';

import { Filters } from '../../content/ContentFilters';
import { Collection } from '@amzn/awscat-pattern-library-service-model';

export interface CommunityCollectionCtxData {
  filteredCollections: Collection[];
  setFilteredCollections: React.Dispatch<React.SetStateAction<Collection[]>>;

  filterOptions: Filters;
  setFilterOptions: React.Dispatch<React.SetStateAction<Filters>>;

  allCollections: Collection[];
  searchTerm: string;
}

// @ts-expect-error TS2345 - strict migration
const CommunityCollectionCtx = createContext<CommunityCollectionCtxData>(undefined);

export default CommunityCollectionCtx;
